import React from 'react';
import { Link, AlertCircle } from 'lucide-react';

const DependencyReviewComponent = ({
    feature,
    dependencies,
    handleNavigateToFeature,
    onConfirm,
    onClose,
    navigationInProgress
}) => {
    console.log('[DEBUG] DependencyReview render:', {
        feature,
        dependencies,
        navigationInProgress
    });

    return (
        <div className="bg-white rounded-lg max-w-2xl w-full shadow-xl">
            <div className="px-6 py-4 border-b flex items-center gap-3">
                <AlertCircle className="w-6 h-6 text-amber-600" />
                <h2 className="text-xl font-semibold flex-1">Review Dependencies</h2>
            </div>

            <div className="p-6">
                <p className="text-gray-700 mb-4">
                    The following features currently depend on {feature?.name}. 
                    Removing the Required status will also clear these system dependencies:
                </p>

                <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
                    <ul className="space-y-3">
                        {dependencies.map((dep, index) => (
                            <li 
                                key={dep.feature_reference || index}
                                className="p-3 rounded-lg transition-colors hover:bg-white/50"
                            >
                                <div className="flex items-start justify-between gap-4">
                                    <div className="flex-1">
                                        <span className="font-medium">{dep.name}</span>
                                        <p className="text-sm mt-1 text-amber-700">
                                            {dep.description}
                                        </p>
                                        {dep.is_system_dependency && (
                                            <span className="inline-block mt-2 text-xs bg-amber-100 text-amber-800 px-2 py-1 rounded-full">
                                                System Dependency
                                            </span>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleNavigateToFeature(dep.feature_reference)}
                                        className="flex items-center px-3 py-1 text-sm text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded"
                                        disabled={navigationInProgress}
                                    >
                                        View Feature
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="px-6 py-4 border-t flex justify-end gap-3">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                    Cancel
                </button>
                <button
                    onClick={onConfirm}
                    className="px-4 py-2 text-sm font-medium text-white bg-amber-600 rounded-md hover:bg-amber-700"
                >
                    Proceed with Changes
                </button>
            </div>
        </div>
    );
};

export default DependencyReviewComponent;